import { ShieldAlert } from "lucide-react";

export default function AccessRestricted() {
  return (
    <div data-testid="access-restricted-page" className="flex min-h-screen items-center justify-center bg-[#07090E] px-4">
      <div className="max-w-md rounded-2xl border border-white/10 bg-[#0D111A] p-8 text-center">
        <ShieldAlert className="mx-auto h-8 w-8 text-amber-300" />
        <h1 className="mt-4 text-2xl font-bold text-white">Access restricted</h1>
        <p className="mt-2 text-sm text-slate-400">This account isn't linked to a Beall Digital Group client or admin. If you were invited, sign in with the email address the invite was sent to.</p>
        <div className="mt-6 flex justify-center gap-3">
          <a href="/login" data-testid="access-restricted-login-link" className="rounded-full bg-cyan-400 px-5 py-2 text-sm font-semibold text-[#07090E] hover:bg-cyan-300">Back to sign in</a>
          <a href="/" data-testid="access-restricted-home-link" className="rounded-full border border-white/15 px-5 py-2 text-sm text-slate-200 hover:border-cyan-400/50">Website</a>
        </div>
      </div>
    </div>
  );
}
